import React from 'react';
import { FadeIn } from './FadeIn';
import { Shield } from 'lucide-react';
export function Guarantee() {
  return <section className="py-16 bg-white" data-id="element-68">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-69">
        <FadeIn data-id="element-70">
          <div className="bg-warm-beige/30 rounded-3xl p-8 md:p-12 text-center border-2 border-warm-beige relative overflow-hidden" data-id="element-71">
            {/* Decorative shield background */}
            <Shield className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-warm-beige/40 w-64 h-64 -z-10" data-id="element-72" />

            <div className="inline-flex items-center justify-center bg-olive-green text-white p-4 rounded-full mb-6" data-id="element-73">
              <Shield size={40} data-id="element-74" />
            </div>

            <h2 className="text-3xl font-serif font-bold text-warm-brown mb-6" data-id="element-75">
              Garantía de 7 días
            </h2>

            <p className="text-lg text-gray-700 leading-relaxed max-w-xl mx-auto" data-id="element-76">
              Si el contenido no te parece claro, útil o práctico, puedes pedir
              tu reembolso dentro de los primeros 7 días.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}